import React, { Component } from "react";
import PropTypes from 'prop-types';
import Chart from "react-apexcharts";
import { Col, Row, CardBody, Card, CardHeader, Label } from 'reactstrap';
import { withRouter } from 'react-router-dom';

const colors1 = ['#FF3500', '#71D800'];
const colors2 = ['#F17B7C', '#26CB97'];
const colors3 = ['#71D800', '#FF7300', '#CC3232'];
const colors4 = ['#FFD800', '#FF7300', '#42A49D', '#71D800'];
class Graficos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options1: {
                labels: ['Carga No Validada', 'Carga Validada'],
                colors: colors1,
                legend: {
                    show: true,
                    horizontalAlign: 'left',
                    position: 'top',
                },
            },
            series1: this.props.series1,
            options2: {
                chart: {
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            //console.log(config.w.config.series[config.dataPointIndex])
                            //console.log(config.w.config.labels[config.dataPointIndex])
                            let type = 0;
                            let delegacion = 0;
                            if(config.w.config.labels[config.dataPointIndex] === 'Sin Delegar'){
                                delegacion = 2;
                            }else if(config.w.config.labels[config.dataPointIndex] === 'Delegado'){
                                delegacion = 1;
                            }
                            this.props.history.push({
                                pathname: '/',
                                state:{
                                    type: type,
                                    delegation: delegacion
                                }
                            });
                          }
                    }
                },
                labels: ['Sin Delegar', 'Delegado'],
                colors: colors2,
                legend: {
                    show: true,
                    horizontalAlign: 'left',
                    position: 'top',
                },
                tooltip: {
                    intersect: true,
                    shared: false
                },
            },
            series2: this.props.series2,
            options3: {
                chart: {
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            //console.log(config.w.config.series[config.dataPointIndex])
                            //console.log(config.w.config.labels[config.dataPointIndex])
                            let type = 0;
                            let delegacion = 2;
                            if(config.w.config.labels[config.dataPointIndex] === 'Atendidas'){
                                type = 1;
                            }else if(config.w.config.labels[config.dataPointIndex] === 'Parcialmente Atendidas'){
                                type = 2;
                            }else if(config.w.config.labels[config.dataPointIndex] === 'Pendientes'){
                                type = 3;
                            }
                            this.props.history.push({
                                pathname: '/',
                                state:{
                                    type: type,
                                    delegation: delegacion
                                }
                            });
                          }
                    },
                    tooltip: {
                        intersect: true,
                        shared: false
                    },
                },
                labels: ['Atendidas', 'Parcialmente Atendidas', 'Pendientes'],
                colors: colors3,
                legend: {
                    show: true,
                    horizontalAlign: 'left',
                    position: 'top',
                }
            },
            series3: this.props.series3,
            options4: {
                chart: {
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            //console.log(config.w.config.series[config.dataPointIndex])
                            //console.log(config.w.config.labels[config.dataPointIndex])
                            let type = 0;
                            let delegacion = 1;
                            if(config.w.config.labels[config.dataPointIndex] === 'Atendidas'){
                                type = 1;
                            }else if(config.w.config.labels[config.dataPointIndex] === 'Parcialmente Atendidas'){
                                type = 2;
                            }else if(config.w.config.labels[config.dataPointIndex] === 'Pendientes'){
                                type = 3;
                            }
                            this.props.history.push({
                                pathname: '/',
                                state:{
                                    type: type,
                                    delegation: delegacion
                                }
                            });
                          }
                    }
                },
                labels: ['Atendidas', 'Parcialmente Atendidas', 'Pendientes'],
                colors: colors4,
                legend: {
                    show: true,
                    horizontalAlign: 'left',
                    position: 'top',
                },
                tooltip: {
                    intersect: true,
                    shared: false
                },
            },
            series4: this.props.series4,
            optionsBar1: {
                plotOptions: {
                    bar: {
                        distributed: true, // this line is mandatory                        
                        barHeight: '95%',
                    },
                },
                colors: colors3,
                legend: {
                    show: false,
                },
                chart: {
                    id: "basic-bar"
                },
                xaxis: {
                    categories: ['Atendidas', 'P. Atendidas', 'Pendientes']
                }
            },
            seriesBar1: [
                {
                    name: "series-1",
                    data: this.props.series3
                }
            ],
            optionsBar2: {                
                colors: colors3,
                legend: {
                    show: false,                    
                },
                plotOptions: {
                    bar: {
                        distributed: true, // this line is mandatory  
                        barHeight: '95%',
                    },
                },
                chart: {
                    id: "basic-bar-2"
                },
                xaxis: {
                    categories: ['Atendidas', 'P. Atendidas', 'Pendientes']
                }
            },
            seriesBar2: [
                {
                    name: "series-2",
                    data: this.props.series4
                }
            ]
        };
    }

    render() {
        return (
            <Row className="d-flex flex-row py-2">
                <Col xs={12} sm={6} md={3} className="py-2">
                    <Card style={{ height: '50vh' }}>
                        <CardHeader style={{ backgroundColor: '#517ED3'}}>
                            <Row>
                                <Col className='col-10 px-2 py-2'>
                                    <Label className='px-2' style={{ justifyContent: 'center', fontSize: 12, color: '#FFFFFF' }}><strong>CARGA</strong></Label>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="donut">
                                {
                                    this.state.series1.every(x => x === 0) ? <>No hay datos que presentar.</>
                                        : <Chart options={this.state.options1} series={this.state.series1} type="pie" />
                                }
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xs={12} sm={6} md={3} className="py-2">
                    <Card style={{ height: '50vh' }}>
                        <CardHeader style={{ backgroundColor: '#396CCD' }}>
                            <Row>
                                <Col className='col-10 px-2 py-2'>
                                    <Label className='px-2' style={{ justifyContent: 'center', fontSize: 12, color: '#FFFFFF' }}><strong>DELEGACIÓN</strong></Label>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="donut">
                                {
                                    this.state.series2.every(x => x === 0) && this.state.series2[1] === 0 ?
                                        <>No hay datos que presentar.</>
                                        : <Chart options={this.state.options2} series={this.state.series2} type="pie" />
                                }
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xs={12} sm={6} md={3} className="py-2">
                    <Card style={{ height: '50vh' }}>
                        <CardHeader style={{ backgroundColor: '#222FAA' }}>
                            <Row>
                                <Col className='col-10 px-2 py-2'>
                                    <Label className='col-12 px-2' style={{ justifyContent: 'center', fontSize: 12, color: '#FFFFFF' }}><strong>DOCENTES/ESTADO ATENCIÓN</strong></Label>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="mixed-chart">
                                {
                                    this.state.series3.every(x => x === 0) && this.state.series3[1] === 0 && this.state.series3[2] === 0 ?
                                        <>No hay datos que presentar.</>
                                        : <Chart options={this.state.optionsBar1} series={this.state.seriesBar1} type="bar" />
                                }
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xs={12} sm={6} md={3} className="py-2">
                    <Card style={{ height: '50vh' }}>
                        <CardHeader style={{ backgroundColor: '#022271' }}>
                            <Row>
                                <Col className='col-10 px-2 py-2'>
                                    <Label className='col-12 px-2' style={{ justifyContent: 'center', fontSize: 12, color: '#FFFFFF' }}><strong>DOCENTES/ESTADO DELEGACIÓN</strong></Label>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            {/*<div className="mixed-chart">*/}
                                {
                                    this.state.series4.every(x => x === 0) && this.state.series4[1] === 0 && this.state.series4[2] === 0
                                        ? <Label>No hay datos que presentar.</Label> :
                                        <Chart options={this.state.optionsBar2} series={this.state.seriesBar2} type="bar" />
                                }
                            {/*</div>*/}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }
}
Graficos.propTypes = {
    series1: PropTypes.array.isRequired,
    series2: PropTypes.array.isRequired,
    series3: PropTypes.array.isRequired,
    series4: PropTypes.array.isRequired,
};
export default withRouter(Graficos);